import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress Chrome extension errors (e.g. CrossPilot, password managers) from triggering the React dev overlay
if (typeof window !== "undefined") {
  const isExtensionError = (err) => {
    const str = String(err?.message || err?.filename || err?.reason?.message || err?.reason || err || "");
    return (
      str.includes("chrome-extension://") ||
      str.includes("chrome: call method") ||
      str.includes("Extension context invalidated") ||
      str.includes("sandbox-content.js")
    );
  };

  window.addEventListener(
    "error",
    (event) => {
      if (isExtensionError(event.error) || isExtensionError(event.filename) || isExtensionError(event.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      if (isExtensionError(event.reason)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );
}

// Disable console logs in production or globally to clean up the browser console
if (process.env.NODE_ENV === "production" || true) {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />  // 🔥 FIXED: Removed StrictMode (no more double requests)
);

reportWebVitals();
